// extracted by mini-css-extract-plugin
export const header = "header-module--header--_rwsu";
export const navList = "header-module--nav-list--1BtLb";
export const navItem = "header-module--nav-item--3weON";
export const navLink = "header-module--nav-link--1ZWsl";
export const activeNavLink = "header-module--active-nav-link--2DDLi";
export const logo = "header-module--logo--tOLth";